import AbstractStorage from './AbstractStorage';
import {jsonParse} from '../utils';

class LocaleStorage extends AbstractStorage {
  static get<T>(key: string): T | null {
    const data = localStorage.getItem(key);

    if (data) return jsonParse(data);
    return null;
  }

  static set<T>(key: string, value: T): void {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }

  static remove(key: string): void {
    localStorage.removeItem(key);
  }

  static clear(): void {
    localStorage.clear();
  }
}

export default LocaleStorage;
